import React from 'react'
import Quiz from './quiz/Components/Quiz/quiz'
import Navbar3 from './Navbar3';

const Upma = () => {
  return (
    <div>
      <Navbar3/>
      <Quiz/>
    </div>
  )
}

export default Upma